import React, { Fragment, useMemo } from 'react';
import ReactTable from "react-table";
import {
    Card,
    CardBody,
    Button,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import DataTablePagination from '../../../../../../components/DatatablePagination';
import ViewLogs from './components/ViewBatchLog';
const BatchesTable = ({ data = [], onOpenLogs, loading }) => {
    const columns = useMemo(() => [
        {
            Header: "Date Time",
            accessor: "dateTime",
            Cell: (props) => <p className="mb-0">{props.value}</p>,
            style: { whiteSpace: 'unset' },
            minWidth: 140
        },
        {
            Header: "Trigger",
            accessor: "trigger",
            Cell: (props) => <p className="mb-0">{props.value || '-'}</p>,
            style: { whiteSpace: 'unset' },
        },
        {
            Header: "Action",
            accessor: "action",
            Cell: (props) => <p className="mb-0">{props.value || '-'}</p>,
            style: { whiteSpace: 'unset' },
        },
        {
            Header: "Channel",
            accessor: "channel",
            Cell: (props) => <p className="mb-0">{props.value || '-'}</p>,
            style: { whiteSpace: 'unset' },
        },
        {
            Header: "Message",
            accessor: "message",
            Cell: (props) => <p className="mb-0">{props.value || '-'}</p>,
            style: { whiteSpace: 'unset' },
            minWidth: 220
        },
        {
            Header: "Scheduled",
            accessor: "totalSent",
            Cell: (props) => <p className="mb-0">{props.value || '-'}</p>,
            style: { whiteSpace: 'unset' },
            width: 100,

        },
        {
            Header: "Delivered",
            accessor: "totalDelivered",
            Cell: (props) => <p className="mb-0">{props.value || '-'}</p>,
            style: { whiteSpace: 'unset' },
            width: 130,

        },
        {
            Header: 'Log',
            id: 'view',
            width: 200,
            Cell: (props) => {
                return (
                    <div
                        className="d-flex align-items-center justify-content-start"
                        style={{ gap: "8px" }}
                    >
                        {/* Edit Button / Component */}
                        <ViewLogs
                            row={props.original.batchNumber}
                            onOpenLogs={onOpenLogs}

                        />


                    </div>
                );
            },
        },
    ], []);
       if (loading) {
            return (
                <Card className="d-flex flex-row mb-3">
                    <CardBody>
                        <h4 style={{ textAlign: 'center' }}>Loading...</h4>
                    </CardBody>
                </Card>
            );
        }

    return (

        <Fragment>
            <Colxx xxs="12" className="mb-2">
                <Card className="mb-2">
                    <CardBody>
                        <Fragment>
                            <ReactTable
                                data={data}
                                columns={columns}
                                defaultPageSize={10}
                                className="-striped -highlight -bordered"
                                filterable={false}
                                //  showPageJump={true}
                                PaginationComponent={DataTablePagination}
                                showPageSizeOptions={true}

                            />
                        </Fragment>

                    </CardBody>
                </Card>
            </Colxx>
        </Fragment>

    );
};

export default BatchesTable;
